import { useEffect, useState } from "react";
import {
  renameColumn,
  updateColumnType,
} from "../../../core/services/appService";

export const useSchemaEditor = (schema, userSessionFileId, fileName, onConfirm) => {
  const [local, setLocal] = useState(() => ({
    columns: schema?.columns ? [...schema.columns] : [],
  }));
  const [lastConfirmed, setLastConfirmed] = useState(null);

  useEffect(() => {
    setLocal({ columns: schema?.columns ? [...schema.columns] : [] });
  }, [schema]);

  const updateColumn = (i, key, value) => {
    setLocal((prev) => {
      const copy = { ...prev, columns: [...prev.columns] };
      copy.columns[i] = { ...copy.columns[i], [key]: value };
      return copy;
    });
  };

  const handleConfirm = async () => {
    if (!userSessionFileId) return;
    const rename_col = {};
    const update_dtype = {};
    local.columns.forEach((col, i) => {
      const oldName = schema.columns[i].name;
      const oldType = schema.columns[i].detectedType;
      if (col.name !== oldName) rename_col[oldName] = col.name;
      if (col.detectedType !== oldType)
        update_dtype[col.name] = col.detectedType;
    });
    try {
      if (Object.keys(rename_col).length > 0)
        await renameColumn(fileName, userSessionFileId, rename_col);
      if (Object.keys(update_dtype).length > 0)
        await updateColumnType(fileName, userSessionFileId, update_dtype);
      setLastConfirmed(JSON.parse(JSON.stringify(local)));
      onConfirm(local);
    } catch (err) {}
  };

  return {
    local,
    lastConfirmed,
    updateColumn,
    handleConfirm,
  };
};